export var DojoRepository = {

    BELOEIL : {
        name: "Shotokan ISKF Beloeil",
        city: "Beloeil",
        url: "/dojo/beloeil",
        geo: {
            lat: 45.5503572, 
            lng: -73.217863
        },
        address: {
            line1: "72 Boul. Sir-Wilfrid-Laurier",
            city: "Beloeil, QC",
            postalCode: "J3G 4G1"
        },
        links: {
            googleMaps: "https://goo.gl/maps/bFFbrCF3BdH2",
        },
        contact: {
            normand: {
                fullName: "Normand Tremblay",
                rank: "4e Dan",
                phone1: "(514) 242-8033",
                email1: "normand.tremblay@quebeciskf.com"
            },
            richard: {
                fullName: "Richard Bureau",
                rank: "1er Dan",
                phone1: "(438) 391-4507",
                email1: "richard.bureau@quebeciskf.com"
            }
        }
    },
    
    BLACK_DRAGON_MONTREAL : {
        name: "Dragon Noir Montréal",
        city: "Côte-Des-Neiges",
        url: "/dojo/black-dragon-montreal",
        geo: {
            lat: 45.4706103, 
            lng: -73.6161349
        },
        address: {
            line1: "5733 Sherbrooke Ouest",
            city: "Montréal, QC",
            postalCode: "H4A 1W9"
        },
        links: {
            googleMaps: "https://goo.gl/maps/Dfb8wzHfnG12",
        },
        contact: {
            gabriel: {
                fullName: "Gabriel Sylla",
                email1: "gabriel.sylla@quebeciskf.com",
                phone1: "(514) 804-5696"
            }
        }
    },

    FIGHTER_ACADEMY : {
        name: "Fighter Academy",
        city: "Villeray-St-Michel",
        url: "/dojo/fighter-academy",
        geo: {
            lat: 45.5609761,
            lng: -73.5966514
        },
        note: "email",
        address: {
            line1: "3441 rue Jean Talon Est",
            city: "Montréal, QC",
            postalCode: "H2A 1X1"
        },
        links: {
            googleMaps: "https://goo.gl/maps/V2c3AAaVxZo",
        },
        contacts: [{
            fullName: "Redhouane Malek",
            phone1: "(514) 299-3616",
            email1: "redhouane.malek@quebeciskf.com"
        }]
    },

    GASPE : {
        name: "Budokan Gaspé",
        city: "Gaspé",
        url: "/dojo/gaspe",
        geo: {
            lat: 48.8645019, 
            lng: -64.4611096
        },
        addresses: [
            {
                line1: "713 Boul. Forillon",
                city: "Gaspé, QC",
                postalCode: "G4X 6T8",
                googleMaps: "https://goo.gl/maps/Hb1DssLMnV92",
            }
        ],
        contacts: [
            {
                fullName: "Alain Giroux",
                phone1: "(418) 361-5173",
                email1: "alain.giroux@quebeciskf.com"
            },
            {
                fullName: "Jean-Noel Blanchette"
            },
            {
                fullName: "Francis Gendron-Troestler"
            }
        ]
    },

    KINGSEY_FALL : {
        name: "Shotokan Karate-Do Kingsey Falls",
        city: "Kingsey Falls",
        url: "/dojo/kingsey-falls",
        geo: {
            lat: 45.8570245,
            lng: -72.0740824
        },
        note: "email",
        address: {
            line1: "7 rue Tardif",
            city: "Kingsey Falls, QC",
            postalCode: "J0A 1B0"
        },
        links: {
            googleMaps: "https://goo.gl/maps/kmqq1cVbZTL2",
        },
        contact: {
            mario: {
                fullName: "Mario Boisvert",
                rank: "2e Dan",
                phone1: "(819) 806-5676",
                email: "karate-kingsey@hotmail.com"
            }
        }
    },
    
    LES_ESCOUMINS : {
        name: "Fudoshin Dojo",
        city: "Les Escoumins",
        url: "/dojo/les-escoumins",
        geo: {
            lat: 48.3490384,
            lng: -69.4097398
        },
        address: {
            buildingName: "Salle Multi Fonctionnelle",
            line1: "23 Route Forestière",
            city: "Les Escoumins, QC",
            postalCode: "G0T 1K0"
        },
        links: {
            googleMaps: "https://goo.gl/maps/uSAR4UKdWbA2",
        },
        contacts: [{
            fullName: "Nick Miller",
            rank: "4e Dan",
            email1: "nick.miller@quebeciskf.com"
        },{
            fullName: "Pierre Chamberland",
            rank: "1er Dan",
            email1: "pierre.chamberland@quebeciskf.com",
            phone1: "(418) 514-9462"
        }]
    },

    LEVIS : {
        name: "Shotokan Lévis",
        city: "Lévis",
        url: "/dojo/levis",
        geo: {
            lat: 46.82698, 
            lng: -71.14508
        },
        address: {
            line1: "578, rue Saint-Joseph",
            city: "Lévis, QC",
            postalCode: "G6V 1H9"
        },
        links: {
            googleMaps: "https://goo.gl/maps/w4S4dShqGA22",
        },
        contact: {
            robin: {
                fullName: "Robin Maheux",
                rank: "6e Dan",
                email1: "robin.maheux@quebeciskf.com",
                phone1: "(418) 835-6813"
            }
        }
    },

    LONGUEUIL : {
        name: "Atlas Karaté Shotokan",
        city: "Longueuil",
        url: "/dojo/longueuil",
        geo: {
            lat: 45.5167622, 
            lng: -73.4903721
        },
        geo2: {
            lat: 45.519307, 
            lng: -73.4395351
        },
        address1: {
            line1: "1865 rue Saint-Georges",
            city: "Longueuil, Qc",
            postalCode: "J4K 4A3",
            googleMaps: "https://goo.gl/maps/4rfXbAkqfJ52"
        },
        address2: {
            line1: "301 rue Cuvillier Est",
            city: "Longueuil, Qc",
            postalCode: "J4L 4T7",
            googleMaps: "https://goo.gl/maps/1u1fscotNHt"
        },
        contact1: {
            fullName: "Abdellatif Aariane",
            rank: "2e Dan",
            phone1: "(514) 802-0071",
            email1: "abdel.aariane@quebeciskf.com"
        },
        note:"rename geo1, facebook, site internet"
    },

    PRINCEVILLE : {
        name: "ISKF Princeville",
        city: "Princeville",
        url: "/dojo/princeville",
        geo: {
            lat: 46.16954, 
            lng: -71.8730126
        },
        address: {
            line1: "48, rue St-Charles",
            city: "Princeville (Québec)",
            postalCode: "G6L 4W4"
        },
        links: {
            googleMaps: "https://goo.gl/maps/iFxB4nvsqND2",
        },
        contact: {
            alain: {
                fullName: "Alain Lavigne",
                rank: "6e Dan",
                email1: "alain.lavigne@quebeciskf.com",
                phone1: "(819) 364-2148"
            }
        }
    },

    PREVOST : {
        name: "Karaté Familial Dynamik",
        city: "Prévost",
        url: "/dojo/prevost",
        geo: {
            lat: 45.83871,
            lng: -74.0586345
        },
        address: {
            buildingName: "Garderie Clos-des-petits-hiboux",
            line1: "525 rue du Clos-des-Ducs",
            city: "Prévost (Québec)",
            postalCode: "J0R 1T0"
        },
        links: {
            googleMaps: "https://goo.gl/maps/8rrTeXaLmJy",
        },
        contact1: {
            fullName: "Francis Blondin",
            email1: "francis.blondin@quebeciskf.com",
            phone1: "(450) 504-6655"
        },
        note: "TODO : rank"
    },
    
    QUEBEC: {
        name: "Dojo Québec Shotokan",
        city: "Québec",
        url: "/dojo/quebec",
        geo: {
            lat: 46.80294,
            lng: -71.22907
        },
        address: {
            buildingName: "Centre des Loisirs Montcalm",
            line1: "265 Boulevard René-Lévesque Ouest / coin des Érables",
            city: "Québec, QC",
            postalCode: "G1R 2A7"
        },
        links: {
            googleMaps: "https://goo.gl/maps/b5SCX8Kpqk72",
        },
        contact: {
            denis: {
                fullName: "Denis Houde",
                rank: "7e Dan",
                email1: "denis.houde@quebeciskf.com",
                email2: "info@quebeciskf.com",
                phone1: "(418) 573-3656"
            }
        }
    },
    
    SAGUENAY : {
        name: "Shotokan ISKF Saguenay",
        city: "Saguenay",
        url: "/dojo/saguenay",
        geo: {
            lat: 48.42255, 
            lng: -71.17554
        },
        note: "link TODO",
        address: {
            buildingName: "Centre Multi-Forme",
            line1: "2748 De la Salle",
            city: "Arvida, QC",
            postalCode: "G7S 2A6"
        },
        links: {
            googleMaps: "https://goo.gl/maps/amt85SuVKCy",
        },
        contact: {
            andre: {
                fullName: "André Maltais",
                email1: "andre.maltais@quebeciskf.com",
                phone1: "(418) 815-6427",
                phone2: "(418) 699-6182",
                rank: "2e Dan"
            }
        }
    },

    SEPT_ILES : {
        name: "Institut Shotokan de Sept-Îles",
        city: "Sept-Îles",
        url: "/dojo/sept-iles",
        geo: {
            lat: 50.21248, 
            lng: -66.37809
        },
        address: {
            buildingName: "Centre socio récréatif de Sept-Iles",
            line1: "500 avenue Jolliet",
            city: "Sept-Îles, QC",
            postalCode: "G4R 2B4"
        },
        links: {
            googleMaps: "https://goo.gl/maps/HsyUR9gDgMM2",
        },
        contact: {
            marco: {
                fullName: "Marco Coulombe",
                rank: "6e Dan",
                email1: "marco.coulombe@quebeciskf.com",
                phone1: "(418) 962-8138"
            },
            alain: {
                fullName: "Alain Méthot",
                rank: "3e Dan",
                phone1: "(418) 968-0984",
                email1: "alain.methot@quebeciskf.com"
            },
            eric : {
                fullName: "Éric Tremblay",
                rank: "5e Dan",
                email1: "eric.tremblay@quebeciskf.com"
            }
        }
    },

    ST_ADOLPHE : {
        name: "Niju Kun St-Adolphe d'Howard",
        city: "St-Adolphe d’Howard",
        url: "/dojo/st-adolphe",
        geo: {
            lat: 45.97055, 
            lng: -74.33890
        },
        address: {
            line1: "110, rue du Collège",
            city: "St-Adolphe d’Howard, QC",
            postalCode: "J0T 2B0"
        },
        links: {
            googleMaps: "https://goo.gl/maps/jzzHDtNtViE2",
        },
        contact: {
            sylvain: {
                fullName: "Sylvain Savard",
                rank: "3e Dan",
                email1: "sylvain.savard@quebeciskf.com",
                phone1: "(819) 327-2346"
            },
            suzanne: {
                fullName: "Suzanne Harvey",
                rank: "2e Dan",
                email1: "suzanne.harvey@quebeciskf.com",
                phone1: "(819) 324-1348"
            }
        }
    },

    ST_JEAN_SUR_RICHELIEU : {
        name: "ISKF St-Jean-sur-Richelieu",
        city: "St-Jean-sur-Richelieu",
        url: "/dojo/st-jean-sur-richelieu",
        geo: {
            lat: 45.36775, 
            lng: -73.30759
        },
        links: {
            googleMaps: "https://goo.gl/maps/jzzHDtNtViE2",
        }
    },

    ST_JEROME : {
        name: "Ganbaru des Laurentides",
        city: "St-Jérôme",
        url: "/dojo/st-jerome",
        geo: {
            lat: 45.79170, 
            lng: -74.01458
        },
        links: {
            googleMaps: "https://goo.gl/maps/27KGsvCXFju",
        }
    },

    VAL_DAVID : {
        name: "Kaiden ISKF Val-David",
        city: "Val-David",
        url: "/dojo/val-david",
        geo: {
            lat: 46.0299136, 
            lng: -74.2082878
        },
        address: {
            buildingName: "École St-Jean-Baptiste",
            line1: "1350 rue de l’Académie",
            city: "Val-David, QC",
            postalCode: "J0T 2N0"
        },
        links: {
            googleMaps: "https://goo.gl/maps/k7Xg3K2Qwxp",
        },
        contact: {
            karine: {
                fullName: "Karinne Papineau",
                rank: "1 Kyu",
                email1: "karine.papineau@quebeciskf.com",
                phone1: "(819) 327-3988"
            }
        }
    },

    VILLE_ST_LAURENT : {
        name: "KIO St-Laurent",
        city: "Saint-Laurent",
        url: "/dojo/ville-st-laurent",
        geo: {
            lat: 45.5036744, 
            lng: -73.6971833
        },
        address: {
            line1: "2505 Côte-Vertu",
            city: "Ville St-Laurent, QC",
            postalCode: "H4R 1P3"
        },
        links: {
            googleMaps: "https://goo.gl/maps/w4Hx4kqDLwQ2",
        },
        contact: {
            aiman: {
                fullName: "Aïman Benkhadra",
                rank: "3e Dan",
                email1: "aiman.benkhadra@quebeciskf.com",
                phone1: "(438) 877-6428"
            },
            alexandre: {
                fullName: "Alexandre Sita",
                rank: "3e Dan",
                email1: "alexandre.sita@quebeciskf.com"
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/data/DojoRepository.js